import { Create as ReactAdminCreate, SimpleForm, TextInput } from "react-admin";

export const Create: React.FC = () => (
    <ReactAdminCreate>
        <SimpleForm>
            <TextInput source="Domain" />
        </SimpleForm>
    </ReactAdminCreate>
);
